module.exports = __webpack_public_path__ + "assets/vehicle_check.5f29e2bc.svg";